import { Route } from '@angular/router'
import { TaxonomyDetailComponent } from '../taxonomy-detail/taxonomy-detail.component'
import { createTaxonomyDefinition } from '../taxonomy-detail/taxonomy.definition'

import { AuthGuard } from '../../abacus/guards/auth.guard'
import { PermissionGuard } from '../../abacus/guards/permission.guard'

import { ToolCountryListComponent } from './tool-country-list/tool-country-list.component'

export const toolCountryRoutes: Route[] = [
  {
    path: 'tool-countries',
    component: ToolCountryListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browseTaxonomies'
    }
  },
  {
    path: 'tool-countries/:id/edit',
    redirectTo: 'tool-countries/:id',
    pathMatch: 'full'
  },
  // TODO: tool-country will be removed very soon here we keep it temporarily for backward compatibility but we had to update the className and slug to match the new structure.
  {
    path: 'tool-countries/:id',
    component: TaxonomyDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      definition: createTaxonomyDefinition({
        className: 'Country',
        nameSingular: 'Tool Country',
        namePlural: 'Tool Countries',
        path: 'tool-countries',
        slug: 'countries',
        title: 'Tool Countries'
      }),
      permission: 'readTaxonomies'
    }
  }
]
